/**
 * URL safety guard for user-supplied hrefs / image sources (PB-234).
 *
 * Allows ONLY `http:` / `https:`. Everything else — `javascript:`, `data:`,
 * `mailto:`, `vbscript:`, `ftp:`, protocol-relative `//host`, bare relative
 * paths, and empty input — is rejected, so the link/image widgets render an
 * inert state instead of a live `<a>`/`<img>`.
 *
 * Parsed with WHATWG `new URL(raw)` and **NO base argument** — this is
 * load-bearing: with a base, `new URL("//evil.com", location.href)` would
 * inherit the page's `https:` and PASS, and a relative path would resolve
 * same-origin instead of being rejected. `new URL()` also strips leading /
 * trailing control+space and embedded tab/newline and lower-cases the scheme
 * before parsing, so `"  https://x"` / `"ht\tps://x"` normalise to a passing
 * `https:` while `" javascript:"` / `"java\tscript:"` normalise to a rejected
 * `javascript:`. Do not add a base argument, and do not replace this with a
 * regex.
 */
export function isSafeHttpUrl(raw: string): boolean {
  try {
    const { protocol } = new URL(raw);
    return protocol === "http:" || protocol === "https:";
  } catch {
    return false;
  }
}
